module.exports = __webpack_public_path__ + "img/fr3.894e9701.png";